/* mm-review-clamp (sections/mm-reviews.liquid, option "Clamp long quotes"): on phones the CSS clamps the quote to 3 lines;
   this adds a Read more / Read less button, only when the text really is longer than 3 lines. Sends nothing. */
(() => {
  if (customElements.get('mm-review-clamp')) return;
  const phone = window.matchMedia('(max-width: 759px)');
  customElements.define('mm-review-clamp', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.body = this.querySelector('[data-body]');
      this.btn = document.createElement('button');
      this.btn.type = 'button';
      this.btn.className = 'mm-reviews__more';
      this.btn.hidden = true;
      this.btn.addEventListener('click', () => { this.classList.toggle('is-open'); this.sync(); });
      this.append(this.btn);
      this.check = () => {
        if (!phone.matches) { this.btn.hidden = true; return; }
        const open = this.classList.contains('is-open');
        this.classList.remove('is-open');
        const clipped = this.body.scrollHeight > this.body.clientHeight + 1;
        if (open) this.classList.add('is-open');
        this.btn.hidden = !(clipped || open);
        this.sync();
      };
      this.sync = () => {
        const open = this.classList.contains('is-open');
        this.btn.textContent = open ? this.dataset.less : this.dataset.more;
        this.btn.setAttribute('aria-expanded', String(open));
      };
      this.ro = new ResizeObserver(() => this.check());
      this.ro.observe(this);
      phone.addEventListener('change', this.check);
      this.check();
    }
    disconnectedCallback() { this.ro?.disconnect(); }
  });
})();

/* mm-judgeme (sections/mm-reviews.liquid, wraps the Judge.me review widget app block; styles in assets/mm-judgeme.css).
   Judge.me renders and re-renders its own markup (sort, rating filter, pages); this only decorates it, as the design shows:
   - each review's avatar circle gets the reviewer's initial (data-mm-initial, drawn by CSS) instead of the person icon;
   - the summary average reads "(4.9)": Judge.me's own data-average-rating cut (not rounded up) to one decimal.
   Changes no Judge.me behaviour and sends nothing. */
(() => {
  if (customElements.get('mm-judgeme')) return;
  customElements.define('mm-judgeme', class extends HTMLElement {
    connectedCallback() {
      if (this.mo) return;
      this.mo = new MutationObserver(() => { cancelAnimationFrame(this.raf); this.raf = requestAnimationFrame(() => this.decorate()); });
      this.mo.observe(this, { childList: true, subtree: true });
      this.decorate();
    }
    disconnectedCallback() { this.mo?.disconnect(); this.mo = null; }
    decorate() {
      this.querySelectorAll('.jdgm-rev').forEach((rev) => {
        const icon = rev.querySelector('.jdgm-rev__icon');
        const name = (rev.querySelector('.jdgm-rev__author')?.textContent || '').trim();
        const initial = name ? name[0].toLocaleUpperCase() : '';
        if (icon && initial && icon.dataset.mmInitial !== initial) icon.dataset.mmInitial = initial;
      });
      const widg = this.querySelector('.jdgm-rev-widg[data-average-rating]');
      const avg = widg && widg.querySelector('.jdgm-rev-widg__summary-average');
      const n = widg ? parseFloat(widg.dataset.averageRating) : NaN;
      if (avg && n > 0) {
        const text = `(${(Math.floor(n * 10 + 1e-9) / 10).toFixed(1)})`;
        if (avg.textContent !== text) avg.textContent = text;
        avg.dataset.mm = '1';
      }
    }
  });
})();
